/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */

import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { useState, useEffect } from "react";
import toast from "react-hot-toast";
import { Divider, Typography, Icon } from "@mui/material";
import InputFileUpload from "./InputFile";
import InputFileDownload from "./InputFileDownload";
import { Button, Tooltip, ButtonGroup, Box } from "@mui/material";
import { FileUploader } from "react-drag-drop-files";
import { PropaneSharp } from "@mui/icons-material";
import { descargarDocumetacionGeneral } from "store/download/dowloadActions";
import { useDispatch, useSelector } from "react-redux";
import DescargarArchivo from "../DescargaArchivos";
import _ from "lodash";
import ModalConfirmacion from "./confirmacion";
import {
  ActualizarEstadoDocumento,
  AddArchivoestudioSocioeconomico,
  ActualizarObservacionesSolicitud,
  DelArchivoSolicitud,
} from "store/solicitudes/solicitudesActions";
import GrupoBotonesEstatus from "./buttonGroupStatus";
import { store } from "store/store";

function DocumentacionAdministrativaEdit({
  documentacionAdministrativa,
  estatusdocumentacion,
  idSolicitud,
  ocultarCampos,
  observacionesDocAdmva,
  esExpediente,
}) {
  const dispatch = useDispatch();
  const [state, setState] = useState({});
  const [campoLoading, setcampoLoading] = useState("");
  const [textInfo, setTextInfo] = useState(observacionesDocAdmva ? observacionesDocAdmva : "");
  const [valorestatus, setvalorestatus] = useState(0);
  const [isvalid_textInfo, isvalid_setTextInfo] = useState(false);
  const [open, setOpen] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [docDelete, setDocDelete] = useState(false);

  const handleConfirm = async () => {
    setOpen(false);
    const res = await dispatch(
      ActualizarEstadoDocumento(idSolicitud, "docAdministrativaValidada", valorestatus)
    );
  };

  const handleConfirmDelete = () => {
    dispatch(
      DelArchivoSolicitud(idSolicitud, {
        tabla: docDelete.tabla,
        campo: docDelete.campo,
        ruta: docDelete.ruta,
        id: docDelete.id,
      })
    );
    setOpenDelete(false);
  };

  useEffect(() => {
    if (!documentacionAdministrativa?.length) return;
    const inicial = {};
    _.map(documentacionAdministrativa, (doc) => {
      inicial[doc.campo] = { ...doc };
    });
    setState(inicial);
  }, [documentacionAdministrativa]);

  const ValidaForm = () => {
    if (!textInfo) {
      toast.error("Ingresa el texto de observación para continuar");
      isvalid_setTextInfo(true);
      return false;
    }

    dispatch(ActualizarObservacionesSolicitud(idSolicitud, "observacionesDocAdmva", textInfo));
  };

  const { progress, loading } = useSelector((state) => state.download);

  useEffect(() => {
    if (!campoLoading?.length) return;
    setState((prevState) => ({
      ...prevState,
      [campoLoading]: {
        ...prevState[campoLoading],
        loading: loading,
      },
    }));
  }, [campoLoading, loading]);

  const DouwloadArchivoGral = async (ruta) => {
    if (!loading) {
      dispatch(descargarDocumetacionGeneral(ruta));
    } else {
      toast.error("Solo es posible descargar un archivo a la vez, por favor a espera!!!");
    }
  };
  const usuarioPermisos = store.getState().login?.usuario?.permisos;

  const cargardocumentos = _.filter(
    usuarioPermisos,
    (p) => p.idPermiso == (esExpediente ? 62 : 15)
  );
  const validarDocumento = _.filter(
    usuarioPermisos,
    (p) => p.idPermiso == (esExpediente ? 63 : 16)
  );
  const eliminarDocumento = _.filter(
    usuarioPermisos,
    (p) => p.idPermiso == (esExpediente ? 64 : 17)
  );
  const validarSeccion = _.filter(usuarioPermisos, (p) => p.idPermiso == (esExpediente ? 65 : 18));
  const guardarObservaciones = _.filter(
    usuarioPermisos,
    (p) => p.idPermiso == (esExpediente ? 66 : 19)
  );

  return (
    <>
      {ocultarCampos ? null : (
        <>
          <Grid container spacing={2}>
            <Grid item xs={12} md={3} lg={3}>
              <MDBox textAlign="left">
                <MDTypography
                  component="a"
                  href="#"
                  variant="caption"
                  color="primary"
                  fontWeight="medium"
                >
                  Documentación administrativa
                </MDTypography>
              </MDBox>
            </Grid>
            <Grid item xs={12} md={9} lg={9}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={12} lg={12}>
                  <MDBox textAlign="right">
                    <GrupoBotonesEstatus
                      estatus={estatusdocumentacion?.docAdministrativaValidada}
                      onSeleccion={(opcion) => {
                        if (validarSeccion.length > 0) {
                          setOpen(true);
                          setvalorestatus(opcion);
                        }
                      }}
                    />
                    <MDTypography
                      ml={2}
                      component="a"
                      href="#"
                      variant="caption"
                      color="primary"
                      fontWeight="medium"
                    >
                      {estatusdocumentacion?.docAdministrativaValidada == 1
                        ? estatusdocumentacion?.docAdministrativaValidadaPor
                        : null}
                    </MDTypography>
                  </MDBox>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Divider />
        </>
      )}

      {_.map(state, (item) => {
        return (
          <>
            <Grid container spacing={2}>
              <Grid item xs={12} md={3} lg={3}>
                <MDBox textAlign="right">
                  <MDTypography
                    variant="h5"
                    color={"white"}
                    style={{ opacity: 0.7, fontSize: "0.9rem" }}
                  >
                    {item.label}
                  </MDTypography>
                </MDBox>
              </Grid>
              <Grid item xs={12} md={9} lg={9}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={12} lg={12}>
                    <MDBox textAlign="left">
                      {item.archivo ? (
                        item.loading ? (
                          <DescargarArchivo progress={progress} />
                        ) : (
                          <InputFileDownload
                            onClick={() => {
                              setcampoLoading(item.campo);
                              DouwloadArchivoGral(item.archivo);
                            }}
                            archivo={item}
                            idSolicitud={idSolicitud}
                            ocultarValidacionarchivo={validarDocumento.length == 0}
                            ocultarEliminacion={eliminarDocumento.length == 0}
                            EliminarDocumento={() => {
                              setDocDelete({
                                tabla: "solicitudes",
                                campo: item.campoBD,
                                ruta: item?.archivo,
                                id: 1,
                              });

                              setOpenDelete(true);
                            }}
                          />
                        )
                      ) : (
                        <>
                          {cargardocumentos.length == 0 ? (
                            " "
                          ) : (
                            <InputFileUpload
                              onchangeFile={(file) => {
                                dispatch(
                                  AddArchivoestudioSocioeconomico(idSolicitud, {
                                    titulo: item.campoBD,
                                    file: file,
                                  })
                                );
                              }}
                              valueF={{ name: " " }}
                            />
                          )}
                        </>
                      )}
                    </MDBox>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Divider style={{ margin: 5 }} />
          </>
        );
      })}
      {ocultarCampos ? null : (
        <>
          <Grid container spacing={2} mt={2}>
            <Grid item xs={12} md={3} lg={3}>
              <MDBox textAlign="right">
                <MDTypography
                  variant="h5"
                  color={"white"}
                  style={{ opacity: 0.7, fontSize: "0.9rem" }}
                >
                  Observaciones
                </MDTypography>
              </MDBox>
            </Grid>
            <Grid item xs={12} md={9} lg={9}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={12} lg={12}>
                  <MDBox textAlign="left">
                    <TextField
                      value={textInfo}
                      onChange={(event) => {
                        setTextInfo(event.target.value);
                      }}
                      onFocus={() => {
                        isvalid_setTextInfo(false);
                      }}
                      label={"Ingrese información adicional"}
                      variant="outlined"
                      style={{ width: "100%", marginBottom: "1.5rem" }}
                      multiline
                      rows={5}
                      size="small"
                      autoComplete="off"
                      InputLabelProps={{ shrink: true }}
                      error={isvalid_textInfo}
                      helperText={
                        isvalid_textInfo ? "En necesario ingresar el texto para continuar" : ""
                      }
                      disabled={guardarObservaciones.length == 0}
                    />
                  </MDBox>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Divider />
          <MDBox textAlign="right">
            {guardarObservaciones.length > 0 ? (
              <Button
                variant="contained"
                onClick={() => ValidaForm()}
                sx={{ mt: 1, mr: 1 }}
                size="small"
                color="primary"
              >
                {"Guardar observaciones"}
              </Button>
            ) : null}
          </MDBox>
        </>
      )}

      <ModalConfirmacion
        open={open}
        onClose={() => setOpen(false)}
        onConfirm={handleConfirm}
        titulo="Comfirmación"
        mensaje="¿Estás seguro que deseas cambiar el estatus?"
      />

      <ModalConfirmacion
        open={openDelete}
        onClose={() => setOpenDelete(false)}
        onConfirm={handleConfirmDelete}
        titulo="Comfirmación"
        mensaje="¿Estás seguro que deseas eliminar este documento?"
      />
    </>
  );
}

export default DocumentacionAdministrativaEdit;
